import { Image } from "@aws-amplify/ui-react"
import { useContext } from "react"
import ConfigurationContext from "../context/ConfigurationContext.js"
import Translation from "../i18n/Translation.js"
import style from "../style/BrandedFooter.module.css"

type Properties = Readonly<{}>

/**
 * @description
 *	The attribution of Sanii, the third party that performs the verification.
 *	It is never hidden: the human being delivers its face here, so the one who
 *	verifies it has to be visible.
 */
export default function BrandedFooter({}: Properties) {
	const configuration = useContext(ConfigurationContext)
	return (
		<div className={style["branded-footer"]}>
			<span className={style["branded-footer-text"]}>
				{Translation[configuration.DEFAULT_LOCALE].landingProvidedBy}
			</span>
			<Image alt="Sanii" className={style["branded-footer-brand"]} src="/brand/sanii.png" />
		</div>
	)
}
